module.exports = __webpack_public_path__ + "img/facebook.6358a9d.svg";